export default (header, body, footer) => {
    return {
        header,
        body,
        footer
    }
}
